import {useRouter} from "vue-router";
import goToAccountManagement from "@/functions/goToAccountManagement";

const pagesThatRedirectToAccountinfo = [
	'/confirm-delete-second-email',
	'/edit-security-settings',
	'/emergency-codes',
	'/enable-auth-app',
	'/enable-auth-app-qr-code',
	'/enable-auth-app-success',
	'/enable-text-verification',
	'/verify-sms',
	'/disable-auth-app-success',
	'/disable-emergency-codes-success',
	'/enable-emergency-codes'
]

const redirectToLogin = () => {
	const router = useRouter()
	if (pagesThatRedirectToAccountinfo.includes(location.pathname))
	{
		goToAccountManagement()
	}
	else {
		router.push('/')
	}
}

export default redirectToLogin